import { MarginPrice } from '@swyftx/margin/build/types';

import { create } from 'zustand';

type MarginPriceState = {
  prices: MarginPrice[];
  setPrices: (prices: MarginPrice[]) => void;
};

const useMarginPricesStore = create<MarginPriceState>()((set) => ({
  prices: [],
  setPrices: (prices: MarginPrice[]) => {
    set({ prices });
  },
}));

export { useMarginPricesStore };
